import React, {PropTypes} from 'react';
import {MainLayout} from 'components/layouts';
import {HomeBannerList} from 'components/home-banners';
import {Link} from 'react-router-dom';

class ListHomeBanners extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <MainLayout>
        <div>
          <h1>Danh sách Banner</h1>
          [ <Link to="home-banners/add">Tạo mới banner</Link>]
          <HomeBannerList/>
        </div>
      </MainLayout>
    );
  }
}

export default ListHomeBanners;



// WEBPACK FOOTER //
// ./pages/home-banners/List.jsx